import React from "react";
import { Section } from "./Section";

export const Pricing = () => {
  return (
    <Section id="pricing" className="bg-zinc-950 py-20 lg:py-24 border-t border-white/5">
      <div className="reveal-up w-full max-w-4xl xl:max-w-5xl mx-auto text-center border border-white/10 rounded-2xl px-8 py-12 lg:px-12 lg:py-14 bg-white/[0.03]">
        <div className="text-xs uppercase tracking-[0.22em] text-[#FF4500] font-semibold">
          Pricing
        </div>
        <h3
          className="mt-3 text-3xl sm:text-4xl font-black tracking-[-0.02em] text-white"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Custom Solutions for Every Budget
        </h3>
        <p className="mt-3 text-sm md:text-base text-zinc-400 max-w-md mx-auto">
          Every environment is different. Tell us what you’re running and we’ll
          come back with a fixed-fee proposal — usually within 48 hours.
        </p>
        <a
          href="#contact"
          data-testid="pricing-request-quote"
          className="mt-7 inline-flex items-center gap-2 bg-[#FF4500] hover:bg-[#ff5a1f] text-white text-sm font-semibold px-6 py-3 rounded-full transition-colors duration-200"
        >
          Request Quote
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </Section>
  );
};

export default Pricing;
